// @ts-nocheck
import PropTypes from 'prop-types';
import { House, CalendarCheck, Info } from '@phosphor-icons/react';
import './DesktopNavigation.css';

const DesktopNavigation = ({ activeTab, onTabChange, tripData = {} }) => {
  const { tripname = '', tenant = {} } = tripData || {};

  const navigationItems = [
    {
      id: 'overview',
      label: 'Overview',
      icon: House,
      weight: 'regular'
    },
    {
      id: 'itinerary',
      label: 'Itinerary',
      icon: CalendarCheck,
      weight: 'regular'
    },
    {
      id: 'info',
      label: 'Info',
      icon: Info,
      weight: 'regular'
    }
    // {
    //   id: 'askme',
    //   label: 'Ask Me',
    //   icon: ChatCircle,
    //   weight: 'regular'
    // }
  ];

  const handleTabClick = (tabId) => {
    onTabChange(tabId);
  };

  return (
    <div className='desktop-navigation'>
      <div className='desktop-navigation__container'>
        {/* Left side - Logo and Trip Name */}
        <div className='desktop-navigation__brand'>
          <div className='desktop-navigation__logo'>
            {tenant?.tenantlogo && (
              <img
                src={tenant?.tenantlogo}
                alt={tenant?.tenantname || 'Logo'}
                draggable='false'
              />
            )}
          </div>
          <h1 className='desktop-navigation__trip-name'>{tripname}</h1>
        </div>

        {/* Right side - Navigation Tabs */}
        <nav
          className='desktop-navigation__nav'
          role='navigation'
          aria-label='Main navigation'
        >
          <ul className='desktop-navigation__nav-list'>
            {navigationItems.map((item) => {
              const IconComponent = item.icon;
              const isActive = activeTab === item.id;

              return (
                <li key={item.id} className='desktop-navigation__nav-item'>
                  <button
                    onClick={() => handleTabClick(item.id)}
                    className={`desktop-navigation__nav-button ${
                      isActive ? 'desktop-navigation__nav-button--active' : ''
                    }`}
                    aria-current={isActive ? 'page' : undefined}
                    aria-label={`Navigate to ${item.label}`}
                  >
                    <IconComponent
                      size={20}
                      weight={isActive ? 'fill' : item.weight}
                      className='desktop-navigation__nav-icon'
                    />
                    <span className='desktop-navigation__nav-label'>
                      {item.label}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

DesktopNavigation.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  tripData: PropTypes.shape({
    name: PropTypes.string
  })
};

export default DesktopNavigation;
